<template>
  <b-modal
    :title=modalTitle
    ref="keyword-search-modal"
    id="keyword-search-modal"
    size="lg"
    hide-footer
  >
    <!-- <b-card class="m-0" style="font-family: NanumBarunGothic;"> -->
    <section>

      <b-row>
        <b-col>
          <b-card class="mb-1" style="font-family: 'NanumBarunGothic';">
            <b-row>
              <b-col style="text-align:center;">
                <h1>월간 검색량</h1>
              </b-col>
            </b-row>
            <b-row style="margin-top: 1rem;">
              <b-col style="text-align:center; font-weight: bold;">
                PC
              </b-col>
              <b-col style="text-align:center; font-weight: bold;">
                MOBILE
              </b-col>
              <b-col style="text-align:center; font-weight: bold;">
                TOTAL
              </b-col>
            </b-row>
            <b-row>
              <b-col style="text-align:center; font-size: 1.5rem;">
                {{ this.pcCnt }}
              </b-col>
              <b-col style="text-align:center; font-size: 1.5rem;">
                {{ this.mobileCnt }}
              </b-col>
              <b-col style="text-align:center; font-size: 1.5rem;">
                {{ this.totalCnt }}
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        
        <b-col>
          <b-card class="mb-1" style="font-family: 'NanumBarunGothic';">
            <b-row>
              <b-col style="text-align:center;">
                <h1>누적 컨텐츠 발행량</h1>
              </b-col>
            </b-row>
            <b-row style="margin-top: 1rem;">
              <b-col style="text-align:center; font-weight: bold;">
                블로그
              </b-col>
              <b-col style="text-align:center; font-weight: bold;">
                카페
              </b-col>
              <b-col style="text-align:center; font-weight: bold;">
                뉴스
              </b-col>
            </b-row>
            <b-row>
              <b-col style="text-align:center; font-size: 1.5rem;">
                {{ this.blogCnt }}
              </b-col>
              <b-col style="text-align:center; font-size: 1.5rem;">
                {{ this.cafeCnt }}
              </b-col>
              <b-col style="text-align:center; font-size: 1.5rem;">
                {{ this.newsCnt }}
              </b-col>
            </b-row>
          </b-card>
        </b-col>


      </b-row>
      

      <b-card ref="comPrintArea1" class="mb-1" style="font-family: 'NanumBarunGothic';">
        <b-row style="margin-top: 20px;">
          <b-col style="text-align:center;">
              <h1>연관 검색어</h1>
          </b-col>
        </b-row>
        
        <b-row style="margin-top: 20px;">
          <!-- <b-col xl="1" md="1" sm="1">
          </b-col>
          <b-col id="keywordsearchDonutCol" xl="5" md="5" sm="5" style="margin-left: -20px;">
            <keywordsearch-chart-donut
            :donutChartData="donutChartData"
            :totalFreq="totalFreq"
            />
          </b-col> -->
          <!-- <b-col id="keywordsearchTableCol" xl="5" md="5" sm="5"> -->
          <b-col id="keywordsearchTableCol">
            <b-table
                  ref="refKeywordsearchTable"
                  :items="fetchGroups"
                  :fields="tableColumns"
                  :busy="isBusy"
                  sort-icon-left
                  responsive
                  show-empty
                  no-border-collapse
                  outlined
                  head-variant="light"
                  hover
                  empty-text="해당하는 키워드가 없습니다."
                  sticky-header="true"
                  class="position-relative mr-1 h-120"
                  style="max-height: 546px;"
                  selectable
                  select-mode="single"
                  @row-selected="onRowSelected"
                  >
              <template #table-busy>
                  <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle mr-2"></b-spinner>
                  <strong>분석중...</strong>
                  </div>
              </template>
            </b-table>
          </b-col>

          <b-col id="keywordsearchTableCol">
            <b-table
                  ref="refKeywordsearchTable"
                  :items="fetchGroups2"
                  :fields="tableColumns"
                  :busy="isBusy"
                  sort-icon-left
                  responsive
                  show-empty
                  no-border-collapse
                  outlined
                  head-variant="light"
                  hover
                  empty-text="해당하는 키워드가 없습니다."
                  sticky-header="true"
                  class="position-relative mr-1 h-120"
                  style="max-height: 546px;"
                  selectable
                  select-mode="single"
                  @row-selected="onRowSelected"
                  >
              <template #table-busy>
                  <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle mr-2"></b-spinner>
                  <strong>분석중...</strong>
                  </div>
              </template>
            </b-table>
          </b-col>



          <!-- <b-col xl="1" md="1" sm="1">
          </b-col> -->
        </b-row>
      </b-card>

      <b-card ref="comPrintArea2" class="mb-1" style="font-family: 'NanumBarunGothic';">
        <b-row style="margin-top: 20px;">
          <b-col style="text-align:center;">
              <h1>검색 트렌드</h1>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
              <keywordsearch-chart-line
                  :keywordsearchChartLine="keywordsearchChartLineSeries(lineChartData)"
                  :lineChartCategories="lineChartCategories"
                  :lineChartDesc="lineChartDesc"
                  :isChartInit="lnChartInit"
                  id="keywordsearchChartLine"
              />
          </b-col>
        </b-row>
      </b-card>


      <b-card ref="comPrintArea3" class="mb-1" style="font-family: 'NanumBarunGothic';">
        <b-row style="margin-top: 20px;">
          <b-col style="text-align:center;">
              <h1>최근 컨텐츠</h1>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-row>
              <b-col style="text-align: center;">
                <strong>BLOG</strong>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
              <div 
                v-for="(item, index) in blogs"
                :key="index"
                class="search-result">
                <div class="title">
                  <a 
                    :href="item.link"
                    target="_blank"
                  ><strong v-html="item.title"></strong></a>
                </div>
                <div class="description" v-html="item.description">
                </div>
              </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col>
            <b-row>
              <b-col style="text-align: center;">
                <strong>CAFE</strong>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
              <div 
                v-for="(item, index) in cafes"
                :key="index"
                class="search-result">
                <div class="title">
                  <a 
                    :href="item.link"
                    target="_blank"
                  ><strong v-html="item.title"></strong></a>
                </div>
                <div class="description" v-html="item.description">
                </div>
              </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>

      <b-card ref="comPrintArea4" class="mb-1" style="font-family: 'NanumBarunGothic';">
        <b-row style="margin-top: 20px;">
          <b-col style="text-align:center;">
              <h1>최근 뉴스</h1>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
              <div 
                v-for="(item, index) in newss"
                :key="index"
                class="search-result2">
                <div class="title2">
                  <a 
                    :href="item.link"
                    target="_blank"
                  ><strong v-html="item.title"></strong></a>
                </div>
                <div class="description2" v-html="item.description">
                </div>
              </div>
          </b-col>
        </b-row>
      </b-card>



    <!-- </b-card> -->
    </section>
  </b-modal>
</template>

<script>
import { 
    BCard, 
    BCol, 
    BRow, 
    BCardBody, 
    BButton,
    BCardText,
    BFormRadio, 
    BTable, 
    BPagination,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BTooltip,
} from "bootstrap-vue";

import KeywordsearchChartDonut from "@/views/cis-keywordsearch/components/KeywordsearchChartDonut.vue";
import KeywordsearchChartLine from "@/views/cis-keywordsearch/components/KeywordsearchChartLine.vue";
import CisKeywordsearchService from "@/services/cis-keywordsearch.service";


import ExportPDF from "@/components/pdfExport";
import debounce from "lodash";

import * as XLSX from 'xlsx';

const stringStyle = { font: { name: 'Consolas' } };
const indexNumStyle = { font: { name: 'Consolas' }, numFmt: "0" };
const intNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0" };
const intNumColorStyle = { font: { name: 'Consolas' }, numFmt: "[Blue]\\ \\▲#,##0;[Red]\\ \\▼#,##0;[Black]\\ \"-\"" };
const floatNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0.0" };
const rateNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0.0%" };
const rateNumColorStyle = { font: { name: 'Consolas' }, numFmt: "[Blue]\\ \\▲#,##0%;[Red]\\ \\▼#,##0%;[Black]\\ \"-\"" };

const boldStyle = { font: { name: 'Consolas', bold: true } };
const underlineStyle = { font: { name: 'Consolas', underline: true} };

const sleep = delay => new Promise(resolve => setTimeout(resolve, delay));


export default {
  name: "KeywordSearchModal",
  components: {
    BCard, 
    BCol, 
    BRow, 
    BCardBody, 
    BButton,
    BCardText,
    BFormRadio, 
    BTable, 
    BPagination,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BTooltip,

    KeywordsearchChartDonut,
    KeywordsearchChartLine

  },
  props: {
    searchKeyword: {
      type: String,
      default: 'default',
    },
  },
  data() {
    return {

      modalTitle: '검색 키워드 정보 - ',

      keyword: '',

      pcCnt: 0,
      mobileCnt: 0,
      totalCnt: 0,

      blogCnt: 0,
      cafeCnt: 0,
      newsCnt: 0,

      blogs: [],
      cafes: [],
      newss: [],

      isPdfExporting: false,
      isXlsExporting: false,

      isBusy: false,
      lnChartInit: false,

      totalFreq: 0,
      donutChartData: [],
      height: 0,

      lineChartCategories: [],
      lineChartData: [],
      lineChartDesc: [],

      fetchGroups: null,
      fetchGroups2: null,

      tableColumns: [
        { key: 'rank', label: '검색량 순위', sortable: true , thClass: 'text-center', thStyle: { width: '20%' },  tdClass: 'text-center' },
        { key: 'relKeyword', label: '키워드', sortable: true , thClass: 'text-center' },
        { key: 'totalCnt_str', label: '지난 1개월 검색량', sortable: true , thClass: 'text-center', tdClass: 'text-right'},
      ],

    };
  },
  watch: {
    
  },
  methods: {
    async onRowSelected(item){
      console.log('-- onRowSelected --')
      if (item.length == 0){
        return
      }
      this.keyword = item[0].relKeyword
      this.loadData(2)
    },

    async loadData(gubun, keyword){
      console.log("-- loadData --")
      if (gubun == 1){
        this.keyword = this.searchKeyword.replace(/(\s*)/g, "")
      }else{
        this.keyword = keyword.replace(/(\s*)/g, "")
      }
      console.log(this.keyword)

      this.modalTitle = '검색 키워드 정보 - ' + this.keyword

      this.lnChartInit = false;

      // 월간 검색량, 연관검색어 세팅
      const response = await CisKeywordsearchService.getNaverAdData({
        searchKeyword : this.keyword
      });
      if (response && response.status === 200) {
        console.log(response)
        // 월간 검색량 세팅
        this.pcCnt = response.data.data[0].pcCnt.toLocaleString()
        this.mobileCnt = response.data.data[0].mobileCnt.toLocaleString()
        this.totalCnt = response.data.data[0].totalCnt.toLocaleString()

        // 연관 검색어 세팅
        var tableArray = response.data.data
        var tableArray_10 = tableArray.slice(1, 11)
        var tableArray_20 = tableArray.slice(11, 21)

        this.fetchGroups = null
        this.fetchGroups = tableArray_10

        this.fetchGroups2 = null
        this.fetchGroups2 = tableArray_20
      }


      // 검색 트랜드 세팅
      const response_line = await CisKeywordsearchService.getDatalabData({
        searchKeyword : this.keyword
      });
      if (response_line && response_line.status === 200) {
        console.log(response_line)

        this.lnChartInit = true;
        this.lineChartData = []
        this.lineChartCategories = []
        this.lineChartDesc = []

        var lineData = []

        for(const item of response_line.data.data) {
          lineData.push(item.rate)
          this.lineChartCategories.push(item.period)
          this.lineChartDesc.push(item.rate)
        }

        this.lineChartData.push({
            brand: this.keyword,
            type: 'line',
            data: lineData,
            hidden: true
        })
      }

      // 컨텐츠 세팅(블로그, 카페, 뉴스)
      const response_contents = await CisKeywordsearchService.getContentsData({
        searchKeyword : this.keyword
      });
      if (response_contents && response_contents.status === 200) {
        console.log('-- contents data --')
        console.log(response_contents)

        // 누적 컨텐츠량 세팅
        this.blogCnt = response_contents.data.data.blogCnt.toLocaleString()
        this.cafeCnt = response_contents.data.data.cafeCnt.toLocaleString()
        this.newsCnt = response_contents.data.data.newsCnt.toLocaleString()

        this.blogs = response_contents.data.data.blogs
        this.cafes = response_contents.data.data.cafes
        this.newss = response_contents.data.data.newss


      }


      


    },
    keywordsearchChartLineSeries(cd) {
        const chartSeries = [];
        for (const item of cd) {

          chartSeries.push({
                  name: item.brand,
                  type: item.type,
                  data: item.data,
                  hidden: false
              })
        }
        return chartSeries;
    },
    
  },
  created() {
    this.lineChartData = [
        { 
            brand: "일월", 
            type: 'line', 
            data: [6, 5, 5, 3, 7, 8, 8, 10, 9], 
            hidden: true
        }
    ];

    this.lineChartCategories = ['24-Jan', '24-Feb', '24-Mar', '24-Apr', '24-May', '24-Jun', '24-Jul', '24-Aug', '24-Sep']

  },
  computed: {


  },
  mounted() {

  }
};
</script>

<style>

.modal-lg,
.modal-xl {
  max-width: 1100px;
}

#keyword-search-modal___BV_modal_title_
{
    font-family: "NanumBarunGothic", Arial, sans-serif !important;
    font-weight: bold;
}

.search-result{
  border-radius : 6px;
  background-color: #fafafa;
  border : 1px solid #e0e0e0;
  margin : 10px 0px;
  padding : 10px 10px;
  text-align : left;
  overflow: hidden;
  display: block;
  width: 35rem;
}
.title{
  display: block;
  width: 100%;
  margin-bottom : 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.title a{
  text-decoration: none;
  color : black;
}
.description{
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.search-result2{
  border-radius : 6px;
  background-color: #fafafa;
  border : 1px solid #e0e0e0;
  margin : 10px 0px;
  padding : 10px 10px;
  text-align : left;
  overflow: hidden;
  display: block;
}
.title2{
  display: block;
  width: 100%;
  margin-bottom : 10px;
}
.title2 a{
  text-decoration: none;
  color : black;
}
.description2{
  font-size: 14px;
}

</style>